









































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as firebase from 'firebase/app';

@Component
export default class Gacha extends Vue {
  @Prop() private msg!: string;

  private key = 'item_key';
  private allItems: Array<{name: string; cal: number; price: number; category: number}> = new Array();
  private items: Array<{name: string; cal: number; price: number; category: number}> = new Array();
  private sumCal: number = 0;
  private sumPrice: number = 0;
  private num: number = 300;
  private message: string = '';
  private init: boolean = false;

  private created() {
    firebase.database().ref('lawson').once('value').then((snapshot) => {
      this.allItems = snapshot.val();
      this.init = true;
    });
  }

  private onClick(): void {
    // 初期化
    this.items = [];
    this.sumCal = 0;
    this.sumPrice = 0;

    while (1) {
      const index = Math.floor(Math.random() * (this.allItems.length + 1));

      // 指定のカロリーを超えたら終了
      if (this.allItems[index].cal + this.sumCal > this.num) {
        if (this.items.length <= 0) {
          this.message = 'ご 飯 な し';
        }
        break;
      }

      // 表示に反映
      this.items.push(this.allItems[index]);
      // 合計値再計算
      this.sumCal += this.allItems[index].cal;
      this.sumPrice += this.allItems[index].price;
    }
  }

  private twitterUrl(): string {
    let menu: string = '';
    if (this.items.length <= 0) {
      menu = 'なし';
    } else {
      for (let i = 0; i < this.items.length; i++) {
        menu += this.items[i].name;
        if (i !== this.items.length - 1) {
          menu += ',';
        }
      }
      menu += ' [合計' + this.sumCal + 'kcal ' + this.sumPrice + '円]';
    }

    return 'https://twitter.com/intent/tweet?url=' + 'https://calculatecalorie.web.app/'
            + '&text=' + '今日のご飯: ' + menu
            + '&hashtags=' + 'ローソンがちゃ';
  }
}
